import styled, { css } from 'styled-components';

import {
    mediaQuery,
    Text,
    SmallCardContainer as UISmallCardContainer,
} from '@catalyze/ui';
import type { LeadGroups } from 'constants/leadGroups';
import { leadGroupColor } from 'utils/leadGroupColor';

export const SmallCardContainer = styled(UISmallCardContainer)`
    grid-template-columns: auto;
`;

export const EmptyText = styled(Text)`
    font-size: ${({ theme }) => theme.fontSizes[3]};
    display: inline-block;
    ${mediaQuery(
        2,
        css`
            font-size: ${({ theme }) => theme.fontSizes[4]};
        `
    )}
`;

interface IEmptyTextAccentProps {
    type: LeadGroups;
}

export const EmptyTextAccent = styled(EmptyText).attrs({
    as: 'span',
})<IEmptyTextAccentProps>`
    color: ${leadGroupColor};
`;
